import { mapActions, mapGetters } from 'vuex'

const PROMPT_TYPES = [
    { value: 'system', text: 'System (API system message)' },
    { value: 'analysis', text: 'Analysis (AB-form task + data)' }
]

export default {
    name: 'setting-prompts',
    data () {
        return {
            showCreateDialog: false,
            showPreviewDialog: false,
            previewText: '',
            previewTitle: '',
            previewItem: null,
            newText: '',
            newType: 'analysis',
            filterType: 'all',
            promptTypes: PROMPT_TYPES,
            activeId: null
        }
    },
    computed: {
        ...mapGetters({
            list: 'settingPrompts/list',
            isLoading: 'settingPrompts/isLoading',
            isListLoading: 'settingPrompts/isListLoading'
        }),
        headers () {
            return [
                { text: 'ID', value: 'id' },
                { text: 'Type', value: 'type', sortable: false },
                { text: 'Current', value: 'current', sortable: false },
                { text: 'Text', value: 'text' },
                { text: 'User ID', value: 'userId' },
                { text: 'Email', value: 'userEmail' },
                { text: 'Created at', value: 'createdAt' },
                { text: 'Actions', value: 'actions', sortable: false }
            ]
        },
        listFilterPayload () {
            if (this.filterType === 'system' || this.filterType === 'analysis') {
                return { type: this.filterType }
            }

            return {}
        },
        previewIsCurrent () {
            return Boolean(this.previewItem && this.previewItem.current)
        }
    },
    watch: {
        filterType () {
            this.fetchList()
        }
    },
    created () {
        this.fetchList()
    },
    methods: {
        ...mapActions({
            create: 'settingPrompts/CREATE',
            setCurrent: 'settingPrompts/SET_CURRENT'
        }),
        openCreate () {
            this.newText = ''
            this.newType = 'analysis'
            this.showCreateDialog = true
        },
        closeCreate () {
            this.showCreateDialog = false
            this.newText = ''
        },
        openTextPreview (item) {
            this.previewItem = item
            this.previewText = item.text != null ? String(item.text) : ''
            this.previewTitle = `Prompt #${item.id} · ${item.type || ''}`
            this.showPreviewDialog = true
        },
        closeTextPreview () {
            this.showPreviewDialog = false
            this.previewText = ''
            this.previewTitle = ''
            this.previewItem = null
        },
        submitPreviewSave () {
            if (!this.previewItem || !this.previewItem.current) {
                return
            }

            const text = this.previewText.trim()

            if (!text || !this.previewItem.type) {
                return
            }

            this.create({
                text,
                type: this.previewItem.type,
                listFilter: this.listFilterPayload
            }).then(() => {
                this.$toasted.success(this.$t('success_created'))
                this.closeTextPreview()
            })
        },
        submitCreate () {
            const text = this.newText.trim()

            if (!text) {
                return
            }

            this.create({
                text,
                type: this.newType,
                listFilter: this.listFilterPayload
            }).then(() => {
                this.$toasted.success(this.$t('success_created'))
                this.closeCreate()
            })
        },
        fetchList () {
            return this.$store.dispatch('settingPrompts/GET_LIST', this.listFilterPayload)
        },
        makeCurrent (item) {
            this.activeId = item.id

            this.setCurrent({
                id: item.id,
                listFilter: this.listFilterPayload
            }).then(() => {
                this.$toasted.success(this.$t('success_updated'))
            }).finally(() => {
                this.activeId = null
            })
        }
    }
}
